module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAQZJREFUSEvt1rsNwjAQBuA7F6kpgJoRGIFswAbQYVfABMAEhMo8CliBCcgGMAIlBArqFHfIiEQCBSUhQaJwOjtOPt3pt2WEhKe+Wo2AaIwAw3Ov50VLKlo3HCF2ZhwSuTeljknfJ81h0mRtudwhc4uZ/YuUbrSmqnVLPCEAOObBikDGz4wVhTJj30OIB2BuPtuaWtnXEBG5CNBFITpZsELQVSm/pvUmC1YYMtW8YMzbQMr2e5pLgR7YfO4hYp+ZZxcpBz+DzI/Nhv60iUurKO2EsFB81pl9ZOKd1rLovW2dbV2cFRsGG4Y/CUN1sRgIgCkQTQKlxvEFcr2uOGG4N2NB5J5yXCDv1Y73KqeKJSoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/Slice 14@2x.png
// module id = uK8t
// module chunks = 2